<template>
  <b-container fluid>
    <div>
      <BaseFacilitySelect
        :is-picked-facility="true"
        :hide-select-one="true"
      >
      </BaseFacilitySelect>
    </div>
    <div>
      <div class="card">
        <div class="card-header">
          <strong>RespSafe registration</strong>
        </div>
        <div class="card-body">
          <b-form @submit.stop.prevent="submit">
            <div>
              <b-form-group id="primaryContact">
                <legend><strong>Primary contact</strong></legend>
                <b-row cols-sm="4">
                  <b-col>
                    <BaseTextInput
                      setId="primaryName"
                      v-model="submission.primaryName"
                      :v="$v.submission.primaryName"
                      slug="primaryName"
                      label="Name"
                      required
                    >
                    </BaseTextInput>
                  </b-col>
                  <b-col>
                    <BaseTextInput
                      setId="primaryTitle"
                      v-model="submission.primaryTitle"
                      :v="$v.submission.primaryTitle"
                      slug="primaryTitle"
                      label="Title"
                      required
                    >
                    </BaseTextInput>
                  </b-col>
                  <b-col>
                    <BaseTextInput
                      setId="primaryEmail"
                      v-model="submission.primaryEmail"
                      :v="$v.submission.primaryEmail"
                      slug="primaryEmail"
                      label="Email"
                      required
                    >
                    </BaseTextInput>
                  </b-col>
                </b-row>
              </b-form-group>
              <b-form-group id="secondaryContact">
                <legend><strong>Secondary contact</strong></legend>
                <b-row cols-sm="4">
                  <b-col>
                    <label for="secondaryName">Name</label><br/>
                    <b-form-input
                      id="secondaryName"
                      setId="secondaryName"
                      v-model="submission.secondaryName"
                      :v="$v.submission.secondaryName"
                      slug="secondaryName"
                      label="secondaryName"
                    >
                    </b-form-input>
                  </b-col>
                  <b-col>
                    <label for="secondaryTitle">Title</label><br/>
                    <b-form-input
                      id="secondaryTitle"
                      setId="secondaryTitle"
                      v-model="submission.secondaryTitle"
                      :v="$v.submission.secondaryTitle"
                      slug="secondaryTitle"
                      label="secondaryTitle"
                    >
                    </b-form-input>
                  </b-col>
                  <b-col>
                    <label for="secondaryEmail">Email</label><br/>
                    <b-form-input
                      id="secondaryEmail"
                      setId="secondaryEmail"
                      v-model="submission.secondaryEmail"
                      :v="submission.secondaryEmail"
                      slug="secondaryEmail"
                      label="secondaryEmail"
                    >
                    </b-form-input>
                  </b-col>
                </b-row>
              </b-form-group>
              <p></p>
              <b-form-group id="strategies">
                <b-row cols-sm="1">
                  <b-col>
                    <legend class="label-required"><strong>Select at least two (2) strategies you plan to implement and/or build upon this respiratory season:</strong></legend>
                    <b-dropdown text="Strategies list">
                      <b-form-group v-slot="{ ariaDescribedby }" role="menu">
                        <b-form-checkbox
                          v-for="option in strategyList"
                          v-model="selectedStrategies"
                          :v="$v.selectedStrategies"
                          :key="option.value"
                          :value="option.value"
                          :aria-describedby="selectedStrategies"
                          name="selectedStrategies"
                          role="menuitemcheckbox"
                        >
                          {{ option.text }}
                        </b-form-checkbox>
                      </b-form-group>
                    </b-dropdown>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <p>Learn more about the strategies at Vaccinating Health Care Workers <a href="https://www.health.state.mn.us/diseases/respiratory/hcp/vaxhcw.html"><u>https://www.health.state.mn.us/diseases/respiratory/hcp/vaxhcw.html</u></a>.</p>
                  </b-col>
                </b-row>
              </b-form-group>
              <div>
                <b-button class="d-block p-2 bg-mdh text-white" size="md" @click="submit">Submit</b-button>
              </div>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
import BaseFacilitySelect from "@/components/templates/input/BaseFacilitySelect.vue";
import axios from "axios";
import router from "@/router";
import {maxLength, minLength, required, requiredIf} from "vuelidate/lib/validators";
import BaseTextInput from "@/components/templates/input/BaseTextInput.vue";

export default {
  name: 'respSafeSubmissionConfirmation',
  components: {BaseTextInput, BaseFacilitySelect},

  data: () => ({
    submission: {
      org: '',
      facility: '',
      primaryName: '',
      primaryTitle: '',
      primaryEmail: '',

      secondaryName: '',
      secondaryTitle: '',
      secondaryEmail: '',

      registrationDate: new Date(),

      strategies: '',

      respiratorySeason: ''
    },
    emailSubmission: {
      email: ' '
    },
    currentFacility: {},
    strategyList:  [
      { value: '• Identify perceptions, motivations, and barriers to vaccination among staff.', text: 'Identify perceptions, motivations, and barriers to vaccination among staff.' },
      { value: '• Promote employee\'s awareness of their immunization history through accessing their record.', text: 'Promote employee\'s awareness of their immunization history through accessing their record.' },
      { value: '• Educate staff on the importance of facilities assessing staff\'s vaccination status.', text: 'Educate staff on the importance of facilities assessing staff\'s vaccination status.' },
      { value: '• Utilize VaxCheck to obtain consent from staff to view immunization information.', text: 'Utilize VaxCheck to obtain consent from staff to view immunization information.' },
      { value: '• Develop a communications plan.', text: 'Develop a communications plan.' },
      { value: '• Set up communication venues for relaying information on vaccination to staff.', text: 'Set up communication venues for relaying information on vaccination to staff.' },
      { value: '• Partner with trusted leaders, peers, or community members who are vaccine advocates.', text: 'Partner with trusted leaders, peers, or community members who are vaccine advocates.' },
      { value: '• Build a positive culture of vaccination.', text: 'Build a positive culture of vaccination.' },
      { value: '• Focus on building trust between leadership and staff, even outside of vaccine efforts.', text: 'Focus on building trust between leadership and staff, even outside of vaccine efforts.' },
      { value: '• Support trusted leaders/peers through a feedback loop.', text: 'Support trusted leaders/peers through a feedback loop.' },
      { value: '• Support clinical staff on how to relay vaccine information to staff.', text: 'Support clinical staff on how to relay vaccine information to staff.' },
      { value: '• Conduct an in-service for staff on the benefits and considerations of vaccination.', text: 'Conduct an in-service for staff on the benefits and considerations of vaccination.' },
      { value: '• Provide to staff culturally specific information from trusted sources.', text: 'Provide to staff culturally specific information from trusted sources.' },
      { value: '• Make vaccines accessible.', text: 'Make vaccines accessible.' },
      { value: '• Roll out the red-carpet during vaccination events for every shift.', text: 'Roll out the red-carpet during vaccination events for every shift.' },
      { value: '• Promote vaccination resources of uninsured or out-of-network insured employees.', text: 'Promote vaccination resources of uninsured or out-of-network insured employees.' },
    ],
    selectedStrategies: []
  }),
  validations() {
    return {
      submission: {
        org: { required },
        facility: { required },
        primaryName: { required, maxLength: maxLength(75) },
        primaryTitle: { required, maxLength: maxLength(75) },
        primaryEmail: { required, maxLength: maxLength(75) },

        secondaryName: { maxLength: maxLength(75) },
        secondaryTitle: { maxLength: maxLength(75) },
        secondaryEmail: { maxLength: maxLength(75) },

        strategies: { required, minLength: minLength(2) },

        respiratorySeason: { required }
      },
      selectedStrategies: { required, minLength: minLength(2) },

    }
  },

  computed: {
    getPrimaryEmail() {
      return this.submission.primaryEmail
    }
  },
  watch: {
    getPrimaryEmail() {
      this.emailSubmission.email = this.submission.primaryEmail
    }
  },
  mounted() {
    this.getFacilityInfo()
    this.handleRespiratorySeason()
  },

  methods: {
    getFacilityInfo() {
      this.submission.facility = this.$store.state.selectedFacility
      this.submission.org = this.$store.state.selectedFacility.org
    },

    handleRespiratorySeason() {
      let startingYear = ''
      let endingYear = ''

      let currUTCYear = new Date(new Date().toUTCString()).toISOString().split('-')[0]
      let currUTCMonth = new Date(new Date().toUTCString()).toISOString().split('-')[1]

      if (currUTCMonth >= 7) {
        startingYear = currUTCYear
        endingYear = parseInt(currUTCYear) + 1
      } else {
        startingYear = parseInt(currUTCYear) - 1
        endingYear = currUTCYear
      }

      this.submission.respiratorySeason = startingYear.toString() + '-' + endingYear.toString()
    },

    submit() {
      this.submission.strategies = this.selectedStrategies.toString()
      this.$v.$touch()
      if (!this.$v.$invalid) {
        axios.post(`${process.env.VUE_APP_API_BASE_URL}/respsafe/registration/submit`, this.submission)
        .then(response => {
          if (response.status === 200) {
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/respsafe/registration/email`, this.emailSubmission)
              .then(response => {
                  router.push('/respSafeSubmission')
                }
              )
          } else {
            this.showRootToast('Error', 'Error submitting request.', 'danger')
          }
        })
      } else if (this.$v.selectedStrategies.$invalid) {
        this.showRootToast('Error', 'Please select at least two (2) strategies.', 'danger')
      } else {
        this.showRootToast('Error', 'Please fix form fields.', 'danger')
      }
    },

    showRootToast(title, message, type) {
      this.$root.$bvToast.toast(message, {
        title: title,
        toaster: 'b-toaster-top-center',
        solid: true,
        variant: type,
        appendToast: true
      })
    },
  }
}
</script>

<style scoped>
.form-group > label {
  font-weight: 100;
}

.label-required::after {
  color: #c70000;
  font-weight: bold;
  font-size: .7em;
  text-transform: uppercase;
  margin-left: 10px;
  content:" required";
}

.btn-group {
  width: 45em;
}

</style>
